import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import NumberHelpers from 'number_helpers';
import cx from 'classnames';

const ArrowChange = ({
  change,
  style,
  units = '%',
  precision = 1,
  separator = '.',
  labels = { thousand: 'K', million: 'M' },
  className,
  upArrowClass = 'hicon-arrow-up',
  downArrowClass = 'hicon-arrow-down',
  showMathOperators = false,
  iconPosition = 'front',
  numberMethod = 'number_to_human',
  showBrackets = false,
  zeroValue = '—',
  withZeroIcon,
  zeroIcon = 'hicon-waves',
}) => {
  let textClass = '';
  let arrowClass = '';
  const abbreviationSettings = {
    precision,
    strip_insignificant_zeros: true,
    space_label: false,
    separator,
    labels,
  };
  if (change > 0) {
    textClass = 'text-green';
    arrowClass = `${upArrowClass} up-arrow`;
  } else if (change < 0) {
    textClass = 'text-rose';
    arrowClass = `${downArrowClass} down-arrow`;
  }

  const formattedChange = NumberHelpers[numberMethod](Math.abs(change), abbreviationSettings);
  if (change === 0 || formattedChange === '0') {
    return (
      <span className={cx('text-nowrap', className)}>
        <span className="arrow-no-change">{zeroValue}</span>
        {withZeroIcon && <i className={zeroIcon} style={{ marginLeft: '4px' }} />}
      </span>
    );
  }

  return (
    <span className={cx('text-nowrap', textClass, className)}>
      {showBrackets && change !== 0 && '('}
      <Fragment>
        {iconPosition === 'front' && <i className={cx('mr-xxxs', arrowClass)} style={style} />}
        {showMathOperators && <span className="mr-xxs">{change > 0 ? '+' : '-'}</span>}
        <span>
          {formattedChange}
          {units}
        </span>
        {iconPosition === 'behind' && <i className={cx('ml-xxxs', arrowClass)} style={style} />}
      </Fragment>
      {showBrackets && change !== 0 && ')'}
    </span>
  );
};

ArrowChange.propTypes = {
  change: PropTypes.number.isRequired,
  style: PropTypes.object,
  labels: PropTypes.object,
  units: PropTypes.string,
  separator: PropTypes.string,
  upArrowClass: PropTypes.string,
  downArrowClass: PropTypes.string,
  className: PropTypes.string,
  precision: PropTypes.number,
  showMathOperators: PropTypes.bool,
  iconPosition: PropTypes.oneOf(['front', 'behind']),
  numberMethod: PropTypes.oneOf(['number_to_human', 'number_with_precision']),
  zeroValue: PropTypes.node,
  withZeroIcon: PropTypes.bool,
  zeroIcon: PropTypes.string,
  showBrackets: PropTypes.bool,
};

export default ArrowChange;
